import styled from 'styled-components';

export const Caption = styled.div`
  width: 100%;
  max-width: 500px;
  font-size: 14px;
  text-align: center;
  margin: 0 auto;
  margin-top: 24px;
  opacity: 0.8;
`;
